module.exports = __webpack_public_path__ + "img/icon_facharzt.7da165ca.svg";